import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import { usePrescriptionFormInput } from "../../../../../../context/steps/PrescriptionFormStep/context/PrescriptionFormInputContext.js";
import { usePrescriptionFormLayout } from "../../../../../../context/steps/PrescriptionFormStep/context/PrescriptionFormLayoutContext.js";
import { usePrescriptionFormLabelWrap } from "../../../../../../hooks/steps/PrescriptionFormStep/hooks/use-prescription-form-label-wrap.js";
/* empty css                                */
const PrescriptionFormInputLabel = ({
  children,
  side,
  isHiddenVisually
}) => {
  const labelRef = React.useRef(null);
  const { layout } = usePrescriptionFormLayout();
  const { labelId, selectId, name } = usePrescriptionFormInput();
  const { getLabel } = useIntl();
  usePrescriptionFormLabelWrap({ labelRef, side });
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("prescription-form-input-label", {
        "prescription-form-input-label--hidden-visually": isHiddenVisually,
        "prescription-form-input-label--is-single-column": layout === "singleColumn"
      }),
      "aria-hidden": isHiddenVisually
    },
    /* @__PURE__ */ React.createElement(
      "label",
      {
        id: labelId,
        htmlFor: selectId,
        className: "prescription-form-input-label__label",
        ref: labelRef
      },
      getLabel(`products.glasses.prescription.${name}`)
    ),
    children
  );
};
export {
  PrescriptionFormInputLabel
};
//# sourceMappingURL=PrescriptionFormInputLabel.js.map
